import React, { useState, useRef } from "react";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import OtpInput from "react-otp-input";

import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../config";
import toast, { Toaster } from "react-hot-toast";

import { Modal } from "antd";
import { parsePhoneNumber } from "react-phone-number-input";
import {
  addPhone_details,
  addPhone_details_Inuser,
  updateUser,
} from "../../Api/firebaseAPis";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { signupFlask } from "../../Api/data";

function PhoneAuthPopup(props) {
  const [number, setNumber] = useState("");

  const [otp, setOtp] = useState(new Array(6).fill(""));

  const otpBoxReference = useRef([]);
  const [hasFilled, setHasFilled] = useState(false);
  const [username, setusername] = useState("");
  const [gender, setGender] = useState("");
  const [fullname, setFullName] = useState("");
  const [uid, setUID] = useState("");
  const recaptchaVerifier = useRef(null);

  const dispatch = useDispatch();

  const GetOpt = () => {
    if (isValidPhoneNumber(number)) {
      recaptchaVerifier.current = new RecaptchaVerifier(
        "recaptcha",
        {
          size: "invisible",
          callback: (response) => {},
        },
        auth
      );
      signInWithPhoneNumber(auth, number, recaptchaVerifier.current)
        .then((confirmationResult) => {
          window.confirmationResult = confirmationResult;
        })
        .catch((error) => {
          toast.error(error);
        });
    } else {
      toast.error("something is worng");
    }
  };

  function handleChange(value, index) {
    let newArr = [...otp];
    newArr[index] = value;
    setOtp(newArr);

    if (value && index < 6 - 1) {
      otpBoxReference.current[index + 1].focus();
    }
  }

  function handleBackspaceAndEnter(e, index) {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      otpBoxReference.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < 6 - 1) {
      otpBoxReference.current[index + 1].focus();
    }
  }

  const updateData = async () => {};

  const confirmOtp = async () => {
    let value = parsePhoneNumber(number);
    let country = value.countryCallingCode;
    let phone = value.nationalNumber;

    if (otp.length === 6) {
      const confirmationResult = window.confirmationResult;
      await confirmationResult
        .confirm(otp.join(""))
        .then(async (result) => {
          const user = result.user;
          addPhone_details(user.uid, phone, country);
          const userDataToSend = {
            firstname: "",
            lastname: "",
            uid: user.uid,
            displayName: user.displayName ? user.displayName : "",
            username: "",
            email: "",
            userObj: user.metadata,
          };
          let data = await signupFlask(userDataToSend);
          //   Add changes here
          console.log(data)
          setUID(user.uid);
          if (Object.keys(data).includes('firstname') && data.firstname) {
            if (user.uid.length > 0) {
              dispatch({
                type: "SET_LOGGED_IN",
                isLoggedIn: true,
              });
              localStorage.setItem("uid", user.uid);
              dispatch({
                type: "SET_PHONENUMBER",
                phoneNumber: number,
              });
              localStorage.setItem("phone", number);
              toast.success("Phone Verified");
              props.setIsPhoneModalOpen(false);
              setTimeout(() => {
                props.setIsModalOpen(true);
              }, 100);
            }
          } else {
            setHasFilled(true);
          }
        })
        .catch((error) => {
          toast.error("User couldn't sign in (bad verification code?)");
        });
    }
  };

  const onRadioChange = (e) => {
    setGender(e.currentTarget.value);
  };

  return (
    <div className="popup" ref={(el) => props.setPopupRef(el)}>
      {/* <div
            className=""
            onClick={() => {
              props.swipeDownAnimation(props.popupRef);
            }}
          >
            <RxCross1 className="text-red-500 cursor-pointer  h-5 w-5 absolute top-2 right-2  bg-transparent" />
          </div> */}
      <div className="popupInside">
        {!hasFilled ? (
          <div className="flex items-center flex-col gap-3 ">
            <h2 className="text-[white] font-semibold text-lg capitalize ">
              Verify Details
            </h2>

            <PhoneInput
              placeholder="Enter phone number"
              className="bg-[black] p-2 rounded-lg shadow-sm w-[80%]"
              defaultCountry="US"
              value={number}
              onChange={setNumber}
              type="tel"
            />

            <button
              onClick={() => {
                console.log(gender);
                console.log(username);
                console.log(number);
                GetOpt();
              }}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transform active:scale-75 transition-transform"
            >
              submit
            </button>

            <div className="flex items-center justify-center flex-col gap-3 ">
              <h2 className="text-[white] font-semibold text-lg capitalize ">
                Verify OTP
              </h2>

              <div className="flex items-center gap-1">
                {otp &&
                  otp.map((digit, index) => (
                    <input
                      key={index}
                      value={digit}
                      max={1}
                      type="tel"
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                      ref={(reference) =>
                        (otpBoxReference.current[index] = reference)
                      }
                      className={`border w-10 h-10 text-white p-3 rounded-md block bg-black focus:border-2 focus:outline-none appearance-none`}
                    />
                  ))}
              </div>

              <button
                onClick={confirmOtp}
                className="bg-blue-500 cursor-pointer hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transform active:scale-75 transition-transform"
              >
                Confirm
              </button>

              <div id="recaptcha"></div>
            </div>
            <div id="recaptcha"></div>
          </div>
        ) : (
          <div className="flex items-center justify-center flex-col gap-3 w-[100%]">
            <h2 className="text-[white] font-semibold text-lg capitalize ">
              Your Details
            </h2>

            <div className="flex items-center gap-1 w-[100%]">
              <div className="data_cont w-[100%]" style={{ paddingTop: 0 }}>
                <div
                  className="data-row w-[100%]"
                  style={{
                    width: "100%",
                  }}
                >
                  <h3 class="mb-4 font-semibold text-gray-900 dark:text-white">
                    Full Name
                  </h3>
                  <input
                    className="input-field rounded-xl"
                    style={{
                      backgroundColor: "black",
                      fontSize: 12,
                      paddingLeft: 20,
                    }}
                    placeholder="Enter your full name"
                    value={fullname}
                    onChange={(e) => {
                      setFullName(e.target.value);
                    }}
                  />
                </div>
                <div
                  className="data-row w-[100%]"
                  style={{
                    width: "100%",
                  }}
                >
                  <h3 class="mb-4 font-semibold text-gray-900 dark:text-white">
                    Gender
                  </h3>
                  <div class="flex">
                    <div class="flex items-center me-4">
                      <input
                        id="inline-radio"
                        type="radio"
                        value="Male"
                        name="inline-radio-group"
                        onChange={onRadioChange}
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                      <label
                        for="inline-radio"
                        class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        Male
                      </label>
                    </div>
                    <div class="flex items-center me-4">
                      <input
                        id="inline-2-radio"
                        type="radio"
                        value="Female"
                        onChange={onRadioChange}
                        name="inline-radio-group"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                      <label
                        for="inline-2-radio"
                        class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        Female
                      </label>
                    </div>
                    <div class="flex items-center me-4">
                      <input
                        checked
                        id="inline-checked-radio"
                        type="radio"
                        value="Other"
                        onChange={onRadioChange}
                        name="inline-radio-group"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                      <label
                        for="inline-checked-radio"
                        class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        Other
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button
              onClick={async () => {
                let fn = fullname.trim();
                let fnsp = fn.split(" ");
                let firstN = fnsp[0];
                let lastN = fnsp.length > 1 ? fnsp[1] : "";
                const userdata = {
                  firstname: firstN,
                  lastname: lastN,
                  username: fn.replace(" ", "."),
                  displayName: fn,
                  gender: gender,
                  uid: uid
                };
                await updateUser(userdata);
                dispatch({
                  type: "SET_LOGGED_IN",
                  isLoggedIn: true,
                });
                localStorage.setItem("uid", uid);
                dispatch({
                  type: "SET_PHONENUMBER",
                  phoneNumber: number,
                });
                localStorage.setItem("phone", number);
                toast.success("Phone Verified");
                props.setIsPhoneModalOpen(false);
                setTimeout(() => {
                  props.setIsModalOpen(true);
                }, 100);
              }}
              className="bg-blue-500 cursor-pointer hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transform active:scale-75 transition-transform"
            >
              Confirm
            </button>

            <div id="recaptcha"></div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PhoneAuthPopup;
